import { ISlotViewItem } from '../../types/interfaces/Slots/Slots';

import { IAmusnetServerGame, IAmusnetGetUrl } from '../../types/interfaces/Slots/Amusnet';
import { IConvertGameList, ISlotConverter } from '../../types/converter';
import { getTab, liveCasinoGames } from './utils';
import { CasinoType } from 'modules/Casino/types/configuration';

class Converter implements ISlotConverter {
  convertGameList = ({ data }: IConvertGameList<IAmusnetServerGame[]>): ISlotViewItem[] => {
    const games = data
      .filter(game => game.id.toString() !== '1' && !liveCasinoGames.includes(game.id.toString()))
      .map((game: IAmusnetServerGame) => ({
        id: game.id.toString(),
        gameId: game.id.toString(),
        description: game.title,
        gameName: game.title,
        provider: 'amusnet',
        type: CasinoType.slots,
        routeProvider: 'amusnet',
        tab: getTab(game.title, game.id.toString()),
        imageUrl: game.details.thumbnails['300x300'],
      }));
    return games;
  };

  convertGameUrl = ({ data }: IAmusnetGetUrl) => data.url;
}
export default Converter;
